import { endpoints } from '@source/config'
const imgBaseUrl = `${endpoints.asset}/images`

const search = `${imgBaseUrl}/search`
export const errorImg = `${search}/error.png`

const radio = `${imgBaseUrl}/radio`
export const unactiveRadioBtn = `${radio}/unactive.png`
export const activeRadioBtn = `${radio}/active.png`

const cb = `${imgBaseUrl}/checkbox`
export const unactiveCbBtn = `${cb}/unactive.png`
export const activeCbBtn = `${cb}/active.png`

const eye = `${imgBaseUrl}/eye`
export const eyeVisible = `${eye}/visible.png`
export const eyeNotVisible = `${eye}/notvisible.png`

const error = `${imgBaseUrl}/error`
export const nightMode404 = `${error}/night-mode-404.png`
export const molaText = `${error}/mola-text.png`
export const lightMode404 = `${error}/light-mode-404.png`
export const internalServerError = `${error}/internal-server-error-502.png`
export const commonError = `${error}/common-error.png`

export const unavailableImg = `${imgBaseUrl}/unavailable-image.png`
export const notificationBarBackground = `${imgBaseUrl}/notification-bar.png`
export const noImg = `${imgBaseUrl}/no-img.png`
export const logoOri = `${imgBaseUrl}/mola.png`
export const logoMobile = `${imgBaseUrl}/mola-logo-mobile.svg`
export const logoBlue = `${imgBaseUrl}/mola-blue.svg`
export const logoHeaderDektop = `${imgBaseUrl}/mola-text-header-desktop.png`
export const logoHorizontal = `${imgBaseUrl}/mola_logo_horizontal.png`
export const logoLandscapeBlue = `${imgBaseUrl}/mola-landscape-blue.svg`
export const oldLogoMolaText = `${imgBaseUrl}/mola_logo_text.png`
export const logoMolaIcon = `${imgBaseUrl}/mola_logo_icon.png`
export const line = `${imgBaseUrl}/line.png`
export const facebook = `${imgBaseUrl}/facebook.png`
export const facebook2 = `${imgBaseUrl}/facebook2.png`
export const facebook3 = `${imgBaseUrl}/facebook3.png`

export const google = `${imgBaseUrl}/google.png`
export const apple = `${imgBaseUrl}/apple.png`
export const appleBlack = `${imgBaseUrl}/apple-black.png`

export const defaultImgClub = `${imgBaseUrl}/defaultImage.svg`

export const viewAllMovieBg = `${imgBaseUrl}/background_darker.png`
export const viewAllMovieBgWebp = `${imgBaseUrl}/background_darker.webp`
export const viewAllMovieMobileBg = `${imgBaseUrl}/background_darker_mobile.png`
export const viewAllMovieMobileBgWebp = `${imgBaseUrl}/background_darker_mobile.webp`

export const placeholderCardLandscape = `${imgBaseUrl}/placeholder-card-landscape.png`
export const placeholderCardPortrait = `${imgBaseUrl}/placeholder-card-portrait.png`

export const placeholderBlankLandscape = `${imgBaseUrl}/placeholder-blank-landscape.png`
export const placeholderBlankPortrait = `${imgBaseUrl}/placeholder-blank-portrait.png`

export const placeholderMolaLogoLandscape = `${imgBaseUrl}/placeholder-mola-logo-landscape.png`
export const placeholderMolaLogoSquare = `${imgBaseUrl}/placeholder-mola-logo-square.png`
export const placeholderMolaLogoPortrait = `${imgBaseUrl}/placeholder-mola-logo-portrait.png`

export const viewAllMovieImg = 'https://cdn01.sent.tv/BCSaWm1FQBSnozrmH74m_sent_1563354762.png'
export const viewAllMovieImgWebp = 'https://cdn01.sent.tv/tEiP59aSTAek9XzGLM04_sent_1563354795.webp'

export const logoMolaBig = `${imgBaseUrl}/logo-mola-big.png`
export const playStoreBadge = `${imgBaseUrl}/google-play-badge@2x_2.png`
export const appStoreBadge = `${imgBaseUrl}/app-store-badge@2x.png`
export const iconMolaSuccess = `${imgBaseUrl}/icon_success.png`
export const iconMolaFailed = `${imgBaseUrl}/icon_fail.png`
export const checkIcon = `${imgBaseUrl}/check.png`
export const crossIcon = `${imgBaseUrl}/cross.png`
export const crossImage = `${imgBaseUrl}/big_cross.png`
export const hourglassImage = `${imgBaseUrl}/wait-time.png`
export const forbidIcon = `${imgBaseUrl}/icon-no-packet.png`
export const checkIconSubs = `${imgBaseUrl}/icon-check-subscription.png`
export const crossIconSubs = `${imgBaseUrl}/icon-cross-subscription.png`
export const checkLargeGreen = `${imgBaseUrl}/check-green.png`
export const accountIcon = `${imgBaseUrl}/account-icon.png`
export const passwordChange = `${imgBaseUrl}/icon-password-changed.png`

export const bcaButton = `${imgBaseUrl}/bca-button.png`

export const coronaImageDesktop = `${imgBaseUrl}/corona-image-d.jpg`
export const coronaImageMobile = `${imgBaseUrl}/corona-image-m.jpg`

export const chevronLeft = `${imgBaseUrl}/chevron-left-new.png`
export const chevronRight = `${imgBaseUrl}/chevron-right-new.png`
export const chevronBottom = `${imgBaseUrl}/chevron-bot.png`
export const leagueImageMobile = `${imgBaseUrl}/imgleaguematches.png`

export const iconPromoEmptyState = `${imgBaseUrl}/art-board.png`
export const emailSent = `${imgBaseUrl}/email_sent.png`

export const iconCheckSuccess = `${imgBaseUrl}/icon_check_success.png`

export const iconLogoHadiah = `${imgBaseUrl}/icon_hadiah.png`
export const iconLogoGift = `${imgBaseUrl}/icon_gift.png`
export const iconLoginFailed = `${imgBaseUrl}/error_login.png`

export const cardVectorBackground = `${imgBaseUrl}/card_desc_bg.png`
export const cardVectorBackgroundMobile = `${imgBaseUrl}/card_desc_bg_m.png`

export const micrositeOrnamentLeft = `${imgBaseUrl}/bg_ornament_left.png`
export const micrositeOrnamentRight = `${imgBaseUrl}/bg_ornament_right.png`

export const continueWatch = `${imgBaseUrl}/continue-watch.png`
export const errorDiagnostic = `${imgBaseUrl}/error-diagnostic.png`

const subs = `${imgBaseUrl}/subscriptions`
export const subscriptionsMockup = `${subs}/subscriptions_mockup_v2.png`
export const heroSubscribeBackground = `${subs}/hero_subscribe_background_v2_optim.jpg`
export const packagesBackgroundMobile = `${subs}/package_background_mobile.png`
export const promoSubscriptionsCard = `${subs}/promo_background_line.png`
export const packagesBackgroundDesktop = `${subs}/package_background_desktop.png`
export const imgCheck = `${imgBaseUrl}/checklist.png`
export const hubsBackground = `${imgBaseUrl}/bg-hub.png`

export const notFoundImg = `${error}/not-found@2x.png`
export const internalServerErrImg = `${error}/internal-server-error@2x.png`

export const placeholderBlankSquare =
  'https://res-mola01.koicdn.com/image/55540e63-f7df-44ce-9553-6c1e4d9bc559/image.png'
export const placeholderBlueSquare =
  'https://res-mola01.koicdn.com/image/84077738-a3da-4b06-88f0-e45f42af781e/image.png'
export const placeholderBlank = 'https://res-mola01.koicdn.com/image/25481e7b-740b-47ac-a9d3-c6ebd455baed/image.png'
export const logoMolaMobile = `${imgBaseUrl}/logo-mola-text-mobile-blue.png`
export const logoMolaText = `${imgBaseUrl}/mola-text-horizontal-blue.png`